import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Image from "next/image";
import { dot } from "../../components/dotlistStyle.js";
import { useI18n } from "@/i18n/I18nProvider.js";
import PageHead from "@/components/PageHead.js";
import { getSarwaText } from "../../../locales/sarwa";

export default function SarwaCapital() {
  const { t, locale } = useI18n();
  const sarwaText = getSarwaText(locale);

  return (
    <>
      <PageHead
        title={t.pages_main_tags.sarwaCapital.title}
        description={t.pages_main_tags.sarwaCapital.meta_desc}
      />

      <Box
        className="horizontal-safe-padding vertical-safe-padding"
        sx={{ lineHeight: "1.9" }}
      >
        {/* Logo/Icon (prevent CLS by fixed intrinsic size + sizes) */}
        <Box sx={{ mb: "10px" }}>
          <Image
            alt="sarwa capital"
            src={sarwaText.sarwa_capital}
            width={90}
            height={90}
            sizes="(max-width: 900px) 40px, 90px"
            style={{ width: "auto", height: "auto", maxWidth: "100%" }}
          />
        </Box>

        <Box
          component="h1"
          sx={{
            color: "#231F20",
            fontSize: { xs: "16px", sm: "16px" },
            fontWeight: "900",
          }}
        >
          {sarwaText.sc_title1}
        </Box>

        <Typography
          variant="h2"
          component="p"
          sx={{
            mt: "20px",
            fontSize: "16px",
            fontWeight: "400",
            maxWidth: "900px",
            whiteSpace: "pre-wrap",
            pb: "30px",
            color: "#686B7A",
          }}
        >
          {sarwaText.sc_body1}
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            alignItems: "center",
            gap: { xs: 3, md: 4 },
          }}
        >
          <Box sx={{ flex: "1 1 340px", minWidth: 0 }}>
            <Box
              component="h2"
              sx={{
                color: "#F18222",
                fontSize: { xs: "21px", sm: "30px" },
                fontWeight: "bold",
                m: 0,
              }}
            >
              {sarwaText.sc_title2}
            </Box>

            <Box
              sx={{
                color: "#545A62",
                fontSize: "16px",
                fontWeight: "400",
                mt: "10px",
                mb: "10px",
              }}
            >
              {sarwaText.sc_subtitle2}
            </Box>

            <Box
              component="ul"
              sx={{
                fontSize: "16px",
                fontWeight: "400",
                ...dot.list,
                px: 2,
                m: 0,
              }}
            >
              {sarwaText.sc_body2.map((item, idx) => (
                <li key={`${idx}-${item}`}>{item}</li>
              ))}
            </Box>
          </Box>

          {/* Right image: likely big visual; reserve space to reduce CLS + optimize loading */}
          <Box
            sx={{
              position: "relative",
              width: { xs: "300px", md: "600px" },
              maxWidth: "100%",
              m: { xs: "auto", md: "initial" },
              // Reserve a stable box to prevent layout shift (adjust ratio if you know actual size)
              aspectRatio: { xs: "16 / 9", md: "600 / 380" },
              flex: "0 0 auto",
            }}
          >
            <Image
              alt="sarwa capital"
              src={sarwaText.sarwa_capital2}
              fill
              sizes="(max-width: 900px) 300px, 600px"
              style={{ objectFit: "contain" }}
              // If this image is above-the-fold, set priority={true}
              priority={false}
            />
          </Box>
        </Box>
      </Box>
    </>
  );
}
